import { FuneralPlan, FuneralSite, FuneralType, FuneralSiteMarker } from 'types';
import { api } from 'utils';

const fetch = (id: string, graveType?: string) =>
  api.get<FuneralSite>(`/funeralsites/${id}`, { params: { graveType } }).then(({ data }) => data);

const fetchDefault = (plan: FuneralPlan, type: FuneralType) =>
  api
    .get<{ funeralSite: FuneralSite; graveType: string }>('/funeralsites/default', {
      params: { plan, type },
    })
    .then(({ data }) => data);

const fetchMarkers = (funeralType: FuneralType, bounds: google.maps.LatLngBounds) =>
  api
    .get<FuneralSiteMarker[]>('/funeralsites/markers', {
      params: {
        activeOnly: true,
        fitBounds: true,
        prices: funeralType === 'sea',
        types: funeralType,
        ...bounds.toJSON(),
      },
    })
    .then(({ data: markers }) => markers);

const fetchClosest = (lat: number, lon: number, type: FuneralType, name: string) =>
  api
    .get<FuneralSite>('/funeralsites/getClosest', {
      params: { lat, lon, name, type },
    })
    .then(({ data }) => data);

export default {
  fetch,
  fetchClosest,
  fetchDefault,
  fetchMarkers,
};
